import { Site } from '@jucy/rentals-api-client';
import { JucyCountryCode } from '@jucy/rentals-common';
import { makeAutoObservable, runInAction, when } from 'mobx';
import ErrorReporter from '../lib/ErrorReporter';
import rentalSitesApiClient from '../services/rentalSitesApiClient';

export type RegionGroupedSites = {
    country: string;
    countryCode: JucyCountryCode;
    sites: Site[];
};

export default class RentalBranchStore {
    branches: Site[] = [];
    loading = true;
    fetching = false;
    loaded = false;
    error?: Error;

    constructor(initialData?: Partial<RentalBranchStore>) {
        makeAutoObservable(this);
        Object.assign(this, initialData);
    }

    loadSites = async (): Promise<Site[]> => {
        if (!this.loaded && this.fetching) {
            await when(() => this.branches.length > 0);
        }
        if (!this.loaded && !this.fetching) {
            try {
                runInAction(() => {
                    this.fetching = true;
                    this.loading = true;
                });
                await rentalSitesApiClient.getAllSites().then((branches) =>
                    runInAction(() => {
                        this.branches = branches;
                    })
                );
            } catch (error) {
                ErrorReporter.reportError({
                    error,
                    tags: {
                        location: 'RentalBranchStore',
                    },
                });
                runInAction(() => {
                    this.error = error;
                });
            }
            runInAction(() => {
                this.loaded = true;
                this.fetching = false;
                this.loading = false;
            });
        }
        return this.branches;
    };

    getBranchByCode = async (code: string): Promise<Site | undefined> => {
        if (!this.branches.length) {
            await this.loadSites();
        }
        return this.branches.find((b) => b.siteCode === code);
    };

    hydrate = (data: Partial<RentalBranchStore>): void => {
        Object.assign(this, data);
    };

    getBranchesByRegion = async (): Promise<RegionGroupedSites[]> => {
        if (!this.branches.length) {
            await this.loadSites();
        }
        return [
            {
                country: 'New Zealand',
                countryCode: JucyCountryCode.nz,
                sites: this.branches?.filter((branch) => branch.countryCode === 'nz'),
            },
            {
                country: 'Australia',
                countryCode: JucyCountryCode.nz,
                sites: this.branches?.filter((branch) => branch.countryCode === 'au'),
            },
        ];
    };
}
